import { formatMoney, formatPercentage } from '@belong/common';
import { Image, Text, Link } from '@belong/ui';

type RentalStatsSectionProps = {
  percentRent: number;
  homeValue: number;
  commuteTime?: number;
  walkingScore?: number;
  transitScore?: number;
  walkscoreLink?: string;
};

export function RentalStatsSection({
  percentRent,
  homeValue,
  commuteTime,
  walkingScore,
  transitScore,
  walkscoreLink,
}: RentalStatsSectionProps) {
  return (
    <div className="gap-y-xl grid grid-cols-2 lg:grid-cols-4">
      <div>
        <div className="mb-xs h-2xl w-2xl">
          <Image src="/city_images/homes_rented.svg" alt="" />
        </div>
        <Text variant="h3" fontWeight="semibold" className="mb-xs">
          {formatPercentage(percentRent / 100)}
        </Text>
        <Text>% Homes Rented</Text>
      </div>
      <div>
        <div className="mb-xs h-2xl w-2xl">
          <Image src="/city_images/median_home_value.svg" alt="" />
        </div>
        <Text variant="h3" fontWeight="semibold" className="mb-xs">
          {formatMoney(homeValue)}
        </Text>
        <Text>Median Home Value</Text>
      </div>
      {walkingScore && (
        <div>
          <div className="mb-xs h-2xl w-2xl">
            <Image src="city_images/walking_score.svg" alt="" />
          </div>
          <Text variant="h3" fontWeight="semibold" className="mb-xs">
            {walkingScore}
          </Text>
          <Text>Walk Score</Text>
          {walkscoreLink ? (
            <Link target="_blank" href={walkscoreLink}>
              <Text className="text-dark-gray capitalize" variant="p1">
                Walk Score®
              </Text>
            </Link>
          ) : (
            <Text className="text-dark-gray" variant="p1">
              Walk Score®
            </Text>
          )}
        </div>
      )}
      <div>
        <div className="mb-xs h-2xl w-2xl">
          <Image src="/city_images/transit_score.svg" alt="" />
        </div>
        <Text variant="h3" fontWeight="semibold" className="mb-xs">
          {commuteTime ? `${commuteTime} mins` : transitScore}
        </Text>
        <Text>{transitScore ? 'Transit Score' : 'Median Commute Time'}</Text>
        {transitScore && (
          // `!`: the one page that sets `transitScore` declares
          // `walkscoreLink` alongside it, and required.
          <Link target="_blank" href={walkscoreLink!}>
            <Text className="text-dark-gray capitalize" variant="p1">
              Transit Score®
            </Text>
          </Link>
        )}
      </div>
    </div>
  );
}
